import GetAsspAd from "@/components/adver/index"
import { abroadAdConfig } from "@/config/adConfig"
import { getOdinData } from "@/request/odinRequest"

export default {
    init: function (opts, deps) {
        if(!opts.showAd) return
        var that = this;
        this.opts = opts;
        this.deps = deps;
        this.thresholds = [];
        that.load(opts);
    },
    load: function (opts) {
        abroadAdConfig && Object.values(abroadAdConfig).forEach(async (adConfig) => {
            const { posCode, rule, fixArray, resourceId, spmCCode, el } = adConfig
            const requestParam = {
                adInfo: {
                    posCode,
                    rule,
                    fixArray
                },
                resourceId,
                spmCCode,
                isSingleAd: true,
            }
            try {
                const data = await getOdinData(requestParam)
                const list = data?.list
                list?.forEach(item => {
                    const renderParam = {
                        data: item?.resourceData,
                        el: document.querySelector(el),
                        spmCode: `${spmCCode}.1`,
                        resourceId: resourceId,
                    }
                    GetAsspAd(renderParam)
                })
            } catch (error) {
                console.log(el,spmCCode,'广告加载或者渲染失败', error)
            }
        })
    }
}